module.exports = __webpack_public_path__ + "img/app-store.e11309a3.svg";